import type { MechKey } from './keys';

export const zh: Partial<Record<MechKey, string>> = {
  'app.eyebrow': '力学 · 2D',
  'panel.scene': '场景',
  'panel.dims': '参数',
  'panel.style': '外观',
  'panel.action': '控制',
  'style.body': '物体',
  'style.vector': '向量',
  'style.ground': '地面',
  'style.forces': '显示力',
  'style.trace': '显示轨迹',
  'style.labels': '向量标签',
  'hint.line1': '点击播放开始 · 拖动物体移动它们',
  'hint.line2': '沙盒：选择一个形状，然后点击放置',
  'scene.incline': '斜面',
  'scene.projectile': '抛体运动',
  'scene.pendulum': '摆',
  'scene.springMass': '弹簧-质量系统',
  'scene.collisions': '碰撞',
  'scene.atwood': '阿特伍德机',
  'scene.circular': '圆周运动',
  'scene.sandbox': '沙盒',
  'dim.angle': '角度 (°)',
  'dim.friction': '摩擦',
  'dim.mass': '质量',
  'dim.massA': '质量 A',
  'dim.massB': '质量 B',
  'dim.velocity': '速度',
  'dim.angleLaunch': '发射角度 (°)',
  'dim.gravity': '重力',
  'dim.gravityX': '重力 x',
  'dim.gravityY': '重力 y',
  'dim.length': '长度',
  'dim.damping': '阻尼',
  'dim.spring': '刚度',
  'dim.restitution': '恢复系数',
  'dim.radius': '半径',
  'dim.speed': '速率',
  'action.play': '播放',
  'action.pause': '暂停',
  'action.step': '步进',
  'action.reset': '重置',
  'action.speed': '速度',
  'action.clear': '清除',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': '重力',
  'forceName.normal': '法向力',
  'forceName.friction': '摩擦力',
  'forceName.tension': '张力',
  'forceName.spring': '弹力',
  'forceName.applied': '施加力',
  'forceName.air': '空气阻力',
  'palette.box': '方块',
  'palette.circle': '球',
  'palette.ramp': '斜坡',
  'palette.ground': '地面',
  'palette.hint': '选择一个形状，然后点击画布放置。',
  'panel.forces': '观察到的力',
  'forces.empty': '尚无 — 播放场景',
};
